import { render } from "./Footnote.vue?vue&type=template&id=562694be&scoped=true"
import script from "./Footnote.vue?vue&type=script&lang=js"
export * from "./Footnote.vue?vue&type=script&lang=js"

import "./Footnote.vue?vue&type=style&index=0&id=562694be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562694be"]])

export default __exports__